import angular from "angular";
import template from "./changelog.html";
import ChangelogController from "./changelog.controller";
import ChangelogDirective from "./Changelog.directive";
import ChangelogEntryModule from "./entry/changelog-entry.module";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.changelog", {
    url: "/changelog",
    controller: ChangelogController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.changelog", [ChangelogDirective.name, ChangelogEntryModule.name])
  .config(config)
  .controller("ChangelogController", ChangelogController);
